import React                                                            from 'react';
import { Button }                                                       from 'react-bootstrap';
import moment                                                           from 'moment';

import { ACTION_DELETE, ACTION_EDIT, ACTION_ENABLE, ACTION_RESET_PASS } from '../extras/actionTypes';
import { ICON_DELETE, ICON_EDIT, ICON_ENABLE, ICON_REDO }               from '../extras/icons';

import BinaryState                                                      from './BinaryState';




const TableBody = props => {


    // ==========================================================================================
    // DECLARACIONES ----------------------------------------------------------------------------
    // ==========================================================================================
    
    //Tomo los props
    const { prefix, headers, items, state } = props;



    // ==========================================================================================
    // RENDERIZO --------------------------------------------------------------------------------
    // ==========================================================================================
    
    return (
        <React.Fragment>
            {   items.map(item => (
                    <tr 
                        key={`${prefix}${item.id}`}
                        className={ state && item[state.field] === state.disabledValue ? state.disabledClass : ''}
                    >
                        {   headers.map((h, index) => (
                                <td
                                    key={`h${prefix}${index}`}
                                    className={`align-middle ${h.style}`}
                                >
                                    {   h.actions && h.actions.length > 0 
                                            ? 
                                                h.actions.filter(a => a.granted).map((action, index) => {
                                                    switch(action.name) {
                                                        case ACTION_RESET_PASS:
                                                            return (
                                                                !state || (state && !(item[state.field] === state.disabledValue && state.hideActions)) 
                                                                    ?
                                                                        <Button
                                                                            key={`abb${prefix}${index}`} 
                                                                            variant="warning" 
                                                                            size="sm" 
                                                                            className={`btn-circle ${index > 0 ? 'ml-2' : ''}`}
                                                                            onClick={() => action.handle(item)}
                                                                        >
                                                                            <ICON_REDO />
                                                                        </Button>
                                                                    :
                                                                        null
                                                            );
                                                        case ACTION_EDIT:
                                                            return (
                                                                !state || (state && !(item[state.field] === state.disabledValue && state.hideActions)) 
                                                                    ?
                                                                        <Button
                                                                            key={`abb${prefix}${index}`} 
                                                                            variant="info" 
                                                                            size="sm" 
                                                                            className={`btn-circle ${index > 0 ? 'ml-2' : ''}`}
                                                                            onClick={() => action.handle(item)}
                                                                        >
                                                                            <ICON_EDIT />
                                                                        </Button>
                                                                    :
                                                                        null
                                                            );
                                                        case ACTION_ENABLE:
                                                            return (
                                                                item[state.field]===state.disabledValue && state.hideActions
                                                                    ?
                                                                        <Button
                                                                            key={`abb${prefix}${index}`} 
                                                                            variant="success" 
                                                                            size="sm" 
                                                                            className={`btn-circle ${index > 0 ? 'ml-2' : ''}`}
                                                                            onClick={() => action.handle(item)}
                                                                        >
                                                                            <ICON_ENABLE />
                                                                        </Button>
                                                                    :
                                                                        null
                                                            );
                                                        case ACTION_DELETE:
                                                            return (
                                                                !state || (state && !(item[state.field] === state.disabledValue && state.hideActions)) 
                                                                    ?
                                                                        <Button
                                                                            key={`abb${prefix}${index}`} 
                                                                            variant="danger" 
                                                                            size="sm" 
                                                                            className={`btn-circle ${index > 0 ? 'ml-2' : ''}`}
                                                                            onClick={() => action.handle(item)}
                                                                        >
                                                                            <ICON_DELETE />
                                                                        </Button>
                                                                    :
                                                                        null
                                                            );
                                                    }
                                                })
                                            : 
                                                <React.Fragment>
                                                    {   item[h.field] != null 
                                                            ? 
                                                                h.subfield 
                                                                    ? 
                                                                        item[h.field][h.subfield] 
                                                                            ? 
                                                                                <span>{item[h.field][h.subfield]}</span>
                                                                            : 
                                                                                null
                                                                    : 
                                                                        h.isBoolean 
                                                                            ? 
                                                                                <BinaryState value={ item[h.field] } />
                                                                            : 
                                                                                h.type==='date' 
                                                                                    ? 
                                                                                        <span>{ moment(item[h.field]).format('DD/MM/YYYY') }</span>
                                                                                    : 
                                                                                        h.field==='grupo'
                                                                                            ?
                                                                                                <span>{ item[h.field]['descripcion'] }</span>
                                                                                            :
                                                                                                <span>{ item[h.field] }</span>
                                                            : 
                                                                null
                                                    }
                                                </React.Fragment>
                                    }
                                </td>
                            ))
                        }
                    </tr>
                ))
            }
        </React.Fragment>
    );
};

export default TableBody;
